export const environment = {
  production: true,
  m2url: 'https://magento.dev.loft.oye.io/',
  defaultStoreCode: 'ee',
  port: 4200,
  expressApiUrl: 'https://api.dev.loft.oye.io/',
  expressApiUrlServer: 'https://api.dev.loft.oye.io',
  ignoreIpRestrictions: false,
  forbidSearchEngineIndexing: true,
};
